// extracted by mini-css-extract-plugin
export default {"dividerSection":"MYvzLI","dividerLine":"rNSX9n"};